
<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  name: "total-cost-comparison-chart",

  props: [ 'series' ],

  watch: {
    series: function() {
      this.render()
    }
  },

  computed: {
    leaseSeries() {
      return this.series.map(o => o.costs.realEstateCost)
    },
    laborSeries() {
      return this.series.map(o => o.costs.laborCost)
    },
    inboundTransportationSeries() {
      return this.series.map(o => o.costs.inboundTransportationCost)
    },
    outboundTransportationSeries() {
      return this.series.map(o => o.costs.outboundTransportationCost)
    },
    
  },

  mounted () {
    this.render()
  },

  methods: {
    tooltipLabel(tooltipItem) {
      let datasetLabels = ["Outbound Transportation", "Inbound Transportation", "Labor", "Lease"]
      let datasetLabel = datasetLabels.length > tooltipItem.datasetIndex ? datasetLabels[tooltipItem.datasetIndex] + " - " : ""
      let totals = this.series[tooltipItem.index]
      let total  = totals.costs.laborCost + totals.costs.realEstateCost + totals.costs.inboundTransportationCost + totals.costs.outboundTransportationCost

      return datasetLabel + "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c
      }) + ` (${(tooltipItem.yLabel / total * 100).toFixed(1)}%)`
    },

    render() {
      this.renderChart({
        labels: this.series.map(o => o.name),
        datasets: [
          {
            label: 'Outbound Transportation',
            data: this.outboundTransportationSeries,
            backgroundColor: '#4471C3'
          }, {
            label: 'Inbound Transportation',
            data: this.inboundTransportationSeries,
            backgroundColor: '#9DC2E5'
          }, { 
            label: 'Labor',
            data: this.laborSeries,
            backgroundColor: '#A5A5A5'
          }, {
            label: 'Lease',
            data: this.leaseSeries,
            backgroundColor: '#FCBF01'
          }
        ]}, {
          legend: {
            display: true,
            labels: {
              fontSize: 15
            }
          },
          tooltips: {
            callbacks: {
              label: this.tooltipLabel
            }
          },
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              stacked: true,
              ticks: {
                suggestedMin: 0,
                userCallback: function(value) {
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);
                  value = value.join(',');
                  return `$${value}`
                },
                fontSize: 17
              },
              scaleLabel: {
                display: true,
                labelString: 'Dollars',
                fontColor: '#999',
                fontSize: 16
              }
            }],
            xAxes: [{
              stacked: true,
              scaleLabel: {
                display: false,
                labelString: 'Expense Categories',
                fontColor: '#999',
                fontSize: 17
              },
              ticks: {
                autoSkip: false,
                fontSize: 15
              }
            }]

          }
        }
      )      
    }
  }
}

</script>